import { AFTER_SALES, SELF_SERVICE } from 'constants/ExtensionConstants';

/** @param {import("modules/users/types/currentUser").CurrentUserData | import("modules/dealers/_types/projections/detailed-dealer").DetailedDealer} userOrDealer  */
export const isSelfServiceOnly = userOrDealer =>
  !userOrDealer?.extensions?.includes(AFTER_SALES) && userOrDealer?.extensions?.includes(SELF_SERVICE);

/**
 * @param {import('modules/questionModels/types').Question} question
 */
export const getResponseFormatter = ({ responses, choices }) =>
  choices.reduce((acc, choice) => (responses.includes(choice.id) ? [...acc, choice] : acc), []);
